import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ActivatedRoute } from '@angular/router';


import { UserLoginLog, UserProfileLog } from '../store/user-managment.actions';
import { environment } from 'src/environments/environment';
import { userInfo } from 'os';




@Component({
  selector: 'app-user-log',
  templateUrl: './user-log.component.html',
  styleUrls: ['./user-log.component.scss']
})
export class UserLogComponent implements OnInit {

  id: string = '';
  userProfileLogs;
  userLoginLogs: [];
  userObj;
  userProfileImgAtLog: string;


  constructor(
    public location: Location,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    this.store.dispatch(new UserProfileLog(this.id))
    this.store.select(state => state.userManagment.userProfileLogs)
      .subscribe(response => {
        this.userProfileLogs = JSON.parse(JSON.stringify(response));
        this.userProfileLogs.forEach(element => {
          element['activityMessage'] = this.getMessage(element);
          element['userProfileImage'] = `${environment.host}/user/getImage/${element.activityBy}`
        });
      }, error => {
        console.log(error);
      });

    this.store.dispatch(new UserLoginLog(this.id))
    this.store.select(state => state.userManagment.userLoginLogs)
      .subscribe(response => {
          if (Object.keys(response).length) {
            this.userObj = response.userInfo;
            this.userLoginLogs = response.history;
            this.userProfileImgAtLog = `${environment.host}/user/getImage/${response.userInfo._id}`
          }
        
      }, error => {
        console.log(error);
      });



  }


  onCancel() {
    this.location.back();
  }


  getMessage(userProfileLog) {
    switch (userProfileLog.activityType) {
      case 'INVITE-USER':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.firstName && userProfileLog.createdAt) {
          return `${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} sent Invitation to ${userProfileLog.profileId.email} .`
        }
        else
          return ''
      case 'REGISTER-USER':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.createdAt) {
          return `${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} has been Registered on CMP .`
        }
        else
          return ''

      case 'EDIT-PROFILE':
        if (userProfileLog.profileId && userProfileLog.profileId.firstName && userProfileLog.profileId.lastName && userProfileLog.createdAt) {
          return `${userProfileLog.profileId.firstName} ${userProfileLog.profileId.lastName} edited their profile for ${userProfileLog.editedFields.length > 0 ? (userProfileLog.editedFields.slice(0, userProfileLog.editedFields.length)) : 'No' } ${userProfileLog.editedFields.length > 1 ? 'fields.' : 'field.'}`
        }
        else
          return ''

      case 'EDIT-PROFILE-BY-ADMIN':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.firstName && userProfileLog.profileId.lastName && userProfileLog.createdAt) {
          return `${userProfileLog.profileId.firstName} ${userProfileLog.profileId.lastName}'s profile has been edited by ${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} for ${userProfileLog.editedFields.length > 0 ? (userProfileLog.editedFields) : 'No'} ${userProfileLog.editedFields.length > 1 ? 'fields.' : 'field.'}`
        }
        else
          return ''

      case 'ACTIVATE-PROFILE':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.firstName && userProfileLog.profileId.lastName && userProfileLog.createdAt) {
          return `${userProfileLog.profileId.firstName} ${userProfileLog.profileId.lastName}'s profile has been activated by ${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} .`
        }
        else
          return ''

      case 'DEACTIVATE-PROFILE':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.firstName && userProfileLog.profileId.lastName && userProfileLog.createdAt) {
          return `${userProfileLog.profileId.firstName} ${userProfileLog.profileId.lastName}'s profile has been deactivated by ${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} .`
        }
        else
          return ''

      case 'RESEND-INVITE-USER':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.email && userProfileLog.createdAt) {
          return `${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} has resent the invitation to ${userProfileLog.profileId.email} .`
        }
        else
          return ''

      case 'EDIT-ROLE':
        if (userProfileLog.activityBy && userProfileLog.activityBy.firstName && userProfileLog.activityBy.lastName && userProfileLog.profileId.firstName && userProfileLog.profileId.lastName && userProfileLog.profileId.email && userProfileLog.createdAt) {
          return `${userProfileLog.profileId.firstName} ${userProfileLog.profileId.lastName}'s role has been edited by ${userProfileLog.activityBy.firstName} ${userProfileLog.activityBy.lastName} .`
        }
        else
          return ''
      case 'NEW_RESPONSE':
        return userProfileLog.message;

    }

  }

  setDefaultPic(item) {
    if (item) {
        item.userProfileImage = "assets/images/user-details-icon.svg";
    }
    else {
        this.userProfileImgAtLog = "assets/images/user-details-icon.svg";
    }
  }


}
